/**
 * 
 * a simple function that toggles between two tiering tables
 * 
 * user instruction:
 * in the pagebuilder; 
 * 1. add a text field with two buttons, 
 *      - button 1 with class tiering-toggle-1
 *      - button 2 with class tiering-toggle-2
 * 2. add two tiering tables to a page in the admin
 *      - tiering table 1 with ID tiering-table-1
 *      - tiering table 2 with ID tiering-table-2
 * 
 */

export default class toggleTieringTables {
    constructor() {
        this.toggleListener();
    }
    toggleListener() {

        // define veriables
        const button1 = document.querySelector(".tiering-toggle-1");
        const button2 = document.querySelector(".tiering-toggle-2");
        const tieringTable1 = document.getElementById("tiering-table-1");
        const tieringTable2 = document.getElementById("tiering-table-2");

        // return false if on of the necessary elements doesn't exist
        if (!button1 || !button2 || !tieringTable1 || !tieringTable2){ return false }

        const column = tieringTable1.closest(".et_pb_column");

        this.changePeriod(tieringTable2);

        // set first tiering table on active by default
        column.classList.add("first-tiering-active");
        column.classList.add("first-tiering-active-delay");
        column.classList.add("tiering-tables-toggle");

        // toggle between active tiering tables when clicking button 1 and 2
        button1.addEventListener("click", function (e) {
            e.preventDefault;
            column.classList.remove("second-tiering-active");
            column.classList.add("first-tiering-active");
            setTimeout(function() {
                column.classList.remove("second-tiering-active-delay")
                column.classList.add("first-tiering-active-delay");
            },500);
        });
        
        button2.addEventListener("click", function (e) {
            e.preventDefault;
            column.classList.remove("first-tiering-active");
            column.classList.add("second-tiering-active");
            setTimeout(function() {
                column.classList.remove("first-tiering-active-delay");
                column.classList.add("second-tiering-active-delay");
            },500);
        });
    }

    // tv gemist is free forever, not per month
    changePeriod(table) {
        let periods = table.querySelectorAll(".tier__period");
        for (let period of periods) {
            period.innerText = "/ altijd";
        }
    }
}